import Component from './Component';
import { onScroll, onResizeDebounced } from '../services/ScrollResizeHandler';

/**
 * --------------------------------------------------------------------------------------------
 * PRIVATE VARIABLES
 * --------------------------------------------------------------------------------------------
 */

let docBody = document.body;
let parallaxBgOffsets = [];
let idx;
let parallaxBg;
let parallaxBgBoundingClientRect;
let parallaxBgOffset;
let parallaxScrollAmount;
let transformStyle;
let rafTimer;


/**
 * --------------------------------------------------------------------------------------------
 * HELPER FUNCTIONS
 * --------------------------------------------------------------------------------------------
 */







/**
 * --------------------------------------------------------------------------------------------
 * EXPORTS
 * --------------------------------------------------------------------------------------------
 */



export default class Parallax extends Component {

    decorator () {
        return {
            selector : '.js-article',
            name : 'Parallax',
        }
    }


    constructor(element) {
        super(element);

        // INITIAL CALLS
        this.cacheElements();

        onScroll(this.renderParallax.bind(this));

        onResizeDebounced(this.renderParallax.bind(this));
    }


    cacheElements () {
        this.$parallax = Array.from(document.querySelectorAll('.js-parallax'));

        if (!this.$parallax.length > 0) { return; }

        this.numOfParallax = this.$parallax.length;

        for (idx = 0; idx < this.numOfParallax; idx++) {
            parallaxBgBoundingClientRect = this.$parallax[idx].getBoundingClientRect();
            parallaxBgOffsets.push(parallaxBgBoundingClientRect.top + docBody.scrollTop)
        }

    }


    renderParallax () {
        if (App.breakpoints.tablet >= App.$window.width()) { return; }
        const render = () => {
            for (idx = 0; idx < this.numOfParallax; idx++) {
                parallaxBgOffset = (docBody.getBoundingClientRect().top * -1) - parallaxBgOffsets[idx];
                parallaxScrollAmount = Math.floor(parallaxBgOffset * 0.2);
                transformStyle = `translateY(${parallaxScrollAmount}px) translateZ(0)`;

                parallaxBg = this.$parallax[idx].querySelector('.js-parallax-block');
                parallaxBg.style.webkitTransform = transformStyle;
                parallaxBg.style.MozTransform = transformStyle;
                parallaxBg.style.msTransform = transformStyle;
                parallaxBg.style.OTransform = transformStyle;
                parallaxBg.style.transform = transformStyle;
            }
        }

        cancelAnimationFrame(rafTimer);

        rafTimer = window.requestAnimationFrame(render);
    }

}
